import MicroModal from 'micromodal';

export class Modal {
	constructor(private element: HTMLElement) {
		MicroModal.init({
			openClass: 'is-open',
			disableScroll: true,
			disableFocus: false,
			awaitOpenAnimation: true,
			awaitCloseAnimation: true,
		});
	}
}
